// Idempotent connection warmer for the checkout domain.
// Optimizes ONLY the DNS lookup + TCP + SSL/TLS handshake phase via
// <link rel="dns-prefetch"> and <link rel="preconnect">.
// It NEVER fetches the checkout, never preloads cart URLs, never creates carts.

let warmed = false
let lastCall = 0
const THROTTLE_MS = 1000

export function warmCheckoutConnection(origin: string) {
  // Idempotent: once warmed, never run again.
  if (warmed) return
  if (typeof document === 'undefined' || !origin) return

  // Throttle guard to avoid bursts of calls before `warmed` is set.
  const now = Date.now()
  if (now - lastCall < THROTTLE_MS) return
  lastCall = now

  // dns-prefetch — resolves DNS early.
  if (!document.querySelector(`link[rel="dns-prefetch"][href="${origin}"]`)) {
    const dns = document.createElement('link')
    dns.rel = 'dns-prefetch'
    dns.href = origin
    document.head.appendChild(dns)
  }

  // preconnect — completes DNS + TCP + TLS handshake ahead of the click.
  // No crossorigin: the checkout is a top-level navigation, so the plain
  // preconnect is the one the browser can reuse for the document request.
  if (
    !document.querySelector(
      `link[rel="preconnect"][href="${origin}"]:not([crossorigin])`,
    )
  ) {
    const pre = document.createElement('link')
    pre.rel = 'preconnect'
    pre.href = origin
    document.head.appendChild(pre)
  }

  warmed = true
}

// Safely derive an origin from a cart base URL (e.g. "http://impulsodigital.vip/cart/").
export function originFromUrl(url: string): string {
  try {
    return new URL(url).origin
  } catch {
    return ''
  }
}
